import networks from './network.mainnet.json'

export interface NetworkType {
    name: string;
    type: string;
    networkId: string;
    id: string;
    endpoint: string;
    socket: string;
    from: string;
    stakingRewardsFactory: string;
    native: string;
    wnative: string;
    rewardsToken: string;
    feeHandler: string;
    http: string;
    bridge: string;
    erc20Handler: string;
    reserveHandler: string;
    oneSplit: string;
    genericHandler: string;
    gasLimit: string;
    maxGasPrice: string;
}

const config_generator = () => {
    let network_config: { [chainId: string]: NetworkType } = {}
    networks.forEach(network => {
        network_config = { ...network_config, [network.networkId]: network }
        return
    })
    return network_config
}

export const NETWORK_CONFIG: { [chainId: string]: NetworkType } = config_generator()